import { cn } from '@anytag/shared-utils';
import { InputNumber as InputNumberBase, InputNumberProps } from '../../input';

export const InputNumber = ({ className, ...restProps }: InputNumberProps) => (
  <InputNumberBase className={cn('min-w-25 text-right', className)} {...restProps} />
);
